const TENSES = {
  "PRESENTE": "p",
  "PRETÉRITO IMPERFEITO": "pi",
  "PRETÉRITO PERFEITO": "pp",
  "PRETÉRITO MAIS-QUE-PERFEITO": "pmqp",
  "FUTURO DO PRESENTE": "fpte",
  "FUTURO DO PRETÉRITO": "fpto",
};

export default TENSES;